<template>
	<div id="app" class="app page-admin" ref="app">
		<MainAdminHeader/>
		
		<!-- Sidebar -->
		<BlockAdminSidebar />

		<main class="site-main site-main--dashboard">

			<router-view/>
		</main>
		<PartBackToTop/>
	</div>
</template>

<script>
import MainAdminHeader from '@/components/main/MainAdminHeader';
import BlockAdminSidebar from '@/components/blocks/Admin/BlockAdminSidebar';
import PartBackToTop from '@/components/parts/PartBackToTop';

export default {
	components: {
		MainAdminHeader,
		BlockAdminSidebar,
		PartBackToTop
	},
	data () {
		return {
			propertiesData: {}
		};
	}
};
</script>

<style lang="scss" scoped>
.site-main--dashboard {
	display: flex;
	flex-direction: column;
	width: calc(100% - 283px);
	margin-left: auto;

	@include mq($xl) {
		width: 100%;
		margin: 0;
		padding: 0 15px;
	}

	&.site-main--full-page {
		width: calc(100% - 240px);

		@include mq($xl) {
			width: 100%;
			margin: 0;
			padding: 0;
		}
	}
}

.app {
	padding-top: 82px;
	padding-bottom: 80px;
	/* height: inherit;*/

	@include mq($xl) {
		padding-top: 80px;
		padding-bottom: 40px;
	}
}
</style>
